import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      position: 'relative',
      paddingTop: 30,
      paddingBottom: 30,
      color: theme.palette.common.white,
      [theme.breakpoints.up('md')]: {
        paddingTop: 50
      }
    },
    slider: {
      marginLeft: -16,
      paddingLeft: 16,
      marginRight: -16,
      paddingRight: 16,
      paddingBottom: 80,

      '&.swiper': {
        position: 'static'
      },
      '& .swiper-button-prev, & .swiper-button-next': {
        zIndex: 15,
        background: '#FFFFFF5C',
        backdropFilter: 'blur(3px)',
        boxShadow: '0px 7px 8px 0px #0261B940 inset',
        width: 30,
        height: 30,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        top: 'auto',
        bottom: 50,
        '&::after': {
          fontSize: 15,
          color: '#FFFAFA',
          [theme.breakpoints.up('md')]: {
            fontSize: 30
          }
        },
        [theme.breakpoints.up('md')]: {
          bottom: 'auto',
          top: 315,
          width: 50,
          height: 50,
          background: '#6A00FF5C',
          backdropFilter: 'blur(5px)',
          boxShadow: '0px 11.67px 13.33px 0px #0261B940 inset'
        }
      },
      '& .swiper-button-prev': {
        left: 'calc((100% - 216px)/2)',
        [theme.breakpoints.up('md')]: {
          left: 80
        }
      },
      '& .swiper-button-next': {
        right: 'calc((100% - 216px)/2)',
        [theme.breakpoints.up('md')]: {
          right: 80
        }
      },
      '& .swiper-pagination': {
        bottom: 58
      },
      '& .swiper-pagination-bullet': {
        background: '#FFFFFF',
        opacity: 0.5,
        width: 5,
        height: 5,
        transition: 'width 0.2s 0.1s, opacity 0.2s 0.1s',
        borderRadius: 2.5,
        '&.swiper-pagination-bullet-active': {
          opacity: 1,
          width: 15
        }
      },
      [theme.breakpoints.up('md')]: {
        marginLeft: 0,
        paddingLeft: 0,
        marginRight: 0,
        paddingRight: 0
      }
    }
  }), { name: 'Winners' }
);
